import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ColumnState, FilterModel } from "ag-grid-community";
import type { IRootState } from "../store";

export interface AgGridSavedState {
  columnState?: ColumnState[] | null;
  filterModel?: FilterModel | null;
  quickFilter?: string | null;
}

// key is a unique identifier for each grid instance, e.g. "ChecklistGrid"
export type AgGridState = Record<string, AgGridSavedState>;

const initialState: AgGridState = {};

export const DEFAULT_GRID_STATE: AgGridSavedState = {
  columnState: null,
  filterModel: null,
  quickFilter: null,
};

export const agGridStateSlice = createSlice({
  name: "agGridState",
  initialState,
  reducers: {
    setAgGridState: (state, action: PayloadAction<{ key: string; data: Partial<AgGridSavedState> }>) => {
      const { key, data } = action.payload;
      state[key] = { ...(state[key] ?? DEFAULT_GRID_STATE), ...data };
    },
    clearAgGridState: (state, action: PayloadAction<{ key: string }>) => {
      delete state[action.payload.key];
    },
  },
});

export const { setAgGridState, clearAgGridState } = agGridStateSlice.actions;

export const selectAgGridStateByKey =
  (key: string) =>
  (rootState: IRootState): AgGridSavedState =>
    rootState.agGridReducer?.[key] ?? DEFAULT_GRID_STATE;

export default agGridStateSlice.reducer;
